<template>
  <div id="components-layout-demo-basic">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <defs>
        <symbol id="icon-search" viewBox="0 0 427.83 427.94">
          <g id="layer1">
            <path id="circle2017"
              d="M192,0C86.17,0,0,86.17,0,192S86.13,384.13,192,384.13A190.78,190.78,0,0,0,311.58,342l80,79.92a21.38,21.38,0,0,0,30.25-30.21l-80-80A191.16,191.16,0,0,0,384,191.92c0-105.79-86.21-192-192-192Zm0,42.67A149.38,149.38,0,1,1,42.66,192.13q0-.08,0-.17A148.94,148.94,0,0,1,191.25,42.67Z"
              transform="translate(0.04 0.08)" />
          </g>
        </symbol>
        <symbol id="icon-wtdelete" viewBox="0 0 20 20">
          <path
            d="M5.27087 17.9375C4.74018 17.9375 4.28803 17.7528 3.91442 17.3833C3.54094 17.0139 3.35421 16.5667 3.35421 16.0417V4.54167H2.14587V2.64584H6.89587V1.66667H13.0834V2.64584H17.8334V4.54167H16.625V16.0417C16.625 16.5581 16.4361 17.0031 16.0582 17.3769C15.6804 17.7506 15.2305 17.9375 14.7084 17.9375H5.27087ZM14.7084 4.54167H5.27087V16.0417H14.7084V4.54167ZM7.43754 14.4167H8.97921V6.125H7.43754V14.4167ZM11.0417 14.4167H12.6042V6.125H11.0417V14.4167Z" />
        </symbol>
        <symbol id="icon-wtedit" viewBox="0 0 20 20">
          <path
            d="M3.9375 16.0417H4.875L13.6875 7.25833L12.7917 6.3125L3.9375 15.1375V16.0417ZM2.0625 17.9375V14.3542L13.9167 2.5C14.0417 2.375 14.1967 2.27083 14.3817 2.1875C14.5667 2.10417 14.7624 2.0625 14.9688 2.0625C15.1665 2.0625 15.3566 2.10417 15.539 2.1875C15.7213 2.27083 15.8958 2.36806 16.0625 2.47917L17.5417 3.91667C17.6806 4.08333 17.7847 4.26028 17.8542 4.4475C17.9236 4.63486 17.9583 4.82563 17.9583 5.01979C17.9583 5.22882 17.9201 5.42708 17.8438 5.61458C17.7674 5.80208 17.669 5.95604 17.5485 6.07646L5.66667 17.9375H2.0625ZM13.25 6.77083L12.7917 6.3125L13.6875 7.25L13.25 6.77083Z" />
        </symbol>
        <symbol id="icon-tab" viewBox="0 0 24 24">
          <path d="M8.02495 17.75H15.975V16.025H8.02495V17.75ZM8.02495 13.525H16V11.825H8.02495V13.525ZM5.72495 22.525C5.12862 22.525 4.60037 22.3007 4.1402 21.8522C3.68003 21.4036 3.44995 20.8695 3.44995 20.25V3.75C3.44995 3.1235 3.68003 2.58358 4.1402 2.13025C4.60037 1.67675 5.12862 1.45 5.72495 1.45H14.825L20.575 7.15V20.25C20.575 20.8695 20.3424 21.4036 19.8772 21.8522C19.4122 22.3007 18.8781 22.525 18.275 22.525H5.72495ZM13.625 8.3V3.75H5.72495V20.25H18.275V8.3H13.625Z"/>
        </symbol>

        <symbol id="icon-btn" viewBox="0 0 24 24">
          <path d="M3.47498 15.05V12.775H12V15.05H3.47498ZM3.47498 10.4V8.125H15.975V10.4H3.47498ZM3.47498 5.75V3.45H15.975V5.75H3.47498ZM12.875 20.525V16.975L18.5 11.4C18.6688 11.2048 18.8666 11.0644 19.0932 10.9787C19.3199 10.8929 19.5555 10.85 19.8 10.85C20.0333 10.85 20.2636 10.9 20.4907 11C20.7179 11.1 20.921 11.2333 21.1 11.4L22.025 12.35C22.1886 12.5167 22.3171 12.7118 22.4102 12.9355C22.5034 13.159 22.55 13.3826 22.55 13.6062C22.55 13.8521 22.502 14.0917 22.406 14.325C22.3098 14.5583 22.1752 14.7667 22.0022 14.95L16.425 20.525H12.875ZM14.725 18.675H15.675L18.625 15.7057L18.175 15.2277L17.7 14.775L14.725 17.719V18.675ZM18.175 15.225L17.7 14.775L18.625 15.7L18.175 15.225Z"/>
        </symbol>

        <symbol id="icon-add" viewBox="0 0 24 24" fill="none">
          <path d="M11.2001 17.1H12.9251V12.95H17.1001V11.225H12.9251V6.9H11.2001V11.225H6.9001V12.95H11.2001V17.1ZM11.9988 22.525C10.5478 22.525 9.17993 22.2533 7.8951 21.71C6.61026 21.1665 5.49076 20.4177 4.5366 19.4635C3.58243 18.5093 2.8336 17.3892 2.2901 16.1032C1.74676 14.8172 1.4751 13.4465 1.4751 11.991C1.4751 10.5372 1.74726 9.171 2.2916 7.8925C2.8361 6.61416 3.58785 5.49541 4.54685 4.53625C5.50585 3.57708 6.6246 2.82291 7.9031 2.27375C9.1816 1.72458 10.5459 1.45 11.9961 1.45C13.4523 1.45 14.8234 1.72383 16.1096 2.2715C17.3958 2.81916 18.5158 3.57125 19.4696 4.52775C20.4234 5.48441 21.1753 6.60541 21.7251 7.89075C22.2751 9.17591 22.5501 10.548 22.5501 12.007C22.5501 13.4647 22.2755 14.8303 21.7263 16.104C21.1772 17.3775 20.423 18.4923 19.4638 19.4485C18.5047 20.4047 17.3845 21.1564 16.1033 21.7037C14.8222 22.2512 13.454 22.525 11.9988 22.525ZM12.0068 20.25C14.2775 20.25 16.2191 19.4467 17.8316 17.8402C19.4439 16.2339 20.2501 14.2849 20.2501 11.9932C20.2501 9.72258 19.4473 7.781 17.8418 6.1685C16.2365 4.55616 14.287 3.75 11.9933 3.75C9.72268 3.75 7.7811 4.55275 6.1686 6.15825C4.55626 7.76358 3.7501 9.71308 3.7501 12.0067C3.7501 14.2774 4.55335 16.219 6.15985 17.8315C7.76618 19.4438 9.71518 20.25 12.0068 20.25Z" fill="#1A73E8"/>
        </symbol>
        <symbol id="icon-save" viewBox="0 0 24 24" fill="none">
          <path d="M21.5501 6.7V19.25C21.5501 19.8697 21.3233 20.4037 20.8698 20.8522C20.4165 21.3007 19.8766 21.525 19.2501 21.525H4.7501C4.13043 21.525 3.59635 21.3007 3.14785 20.8522C2.69935 20.4037 2.4751 19.8697 2.4751 19.25V4.75C2.4751 4.1235 2.69935 3.58358 3.14785 3.13025C3.59635 2.67675 4.13043 2.45 4.7501 2.45H17.3001L21.5501 6.7ZM19.2501 7.71475L16.2853 4.75H4.7501V19.25H19.2501V7.71475ZM11.9913 17.6C12.6972 17.6 13.3001 17.3529 13.8001 16.8587C14.3001 16.3647 14.5501 15.7647 14.5501 15.0587C14.5501 14.3529 14.303 13.75 13.8088 13.25C13.3148 12.75 12.7148 12.5 12.0088 12.5C11.303 12.5 10.7001 12.7471 10.2001 13.2412C9.7001 13.7352 9.4501 14.3352 9.4501 15.0412C9.4501 15.7471 9.69718 16.35 10.1913 16.85C10.6853 17.35 11.2853 17.6 11.9913 17.6ZM6.1001 9.575H14.9501V6.1H6.1001V9.575ZM4.7501 7.71475V19.25V4.75V7.71475Z" fill="white"/>
        </symbol>
        <symbol id="icon-handle" viewBox="0 0 1024 1024">
          <path d="M256 213.333333a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z" p-id="2406"></path>
          <path d="M597.333333 213.333333a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z" p-id="2407"></path>
          <path d="M256 512a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z" p-id="2408"></path>
          <path d="M597.333333 512a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z" p-id="2409"></path>
          <path d="M256 810.666667a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z" p-id="2410"></path>
          <path d="M597.333333 810.666667a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z" p-id="2411"></path>
        </symbol>
      </defs>
    </svg>
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="border-bottom:1px solid #eeeeee;margin-top:10px;">
        <div class="container clearfix" style="position: relative;">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;width:200px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/SnippetsIcon.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo WT3T</span>
            </div>
          </router-link>
          <!--   搜索框   -->
          <!-- <div style="float:left;margin-left:188px;height:40px;position:relative;">
            <a-auto-complete v-model="searchName" style="float:left;width:365px;" placeholder="Search Name"
              spellcheck="false" @select="onNameSelect" @change="onNameChange">
              <template slot="dataSource">
                <a-select-option v-for="item in searchList" :key="item.employee_id"
                  :value="`${item.employee_id},${item.nickname},${item.username}`">
                  <img v-if="item.profile_picture" :src="item.profile_picture" alt=""
                    style="width:40px;height:40px;border-radius:50%;">
                  <img v-else src="@/assets/Images/defaultavatar.jpeg" alt=""
                    style="width:40px;height:40px;border-radius:50%;">
                  <span style="margin-left:12px;">{{ item.nickname }}</span>
                </a-select-option>
              </template>
              <a-input>
              </a-input>
            </a-auto-complete>
            <svg width="16" height="16" style="position:absolute;right:14px;top:12px;z-index:99;cursor:pointer;">
              <use xlink:href="#icon-search"></use>
            </svg>
          </div> -->
          <div style="width:40px;height:40px;float: right;border-radius: 50%;cursor: pointer" @click="backToReport">
            <img :src="avatar" alt="" style="width:100%;height:100%;border-radius: 50%;margin-bottom:26px;">
          </div>

          <a-select v-model="year" style="float:right;width:100px;margin-right:32px;margin-top: 4px;"
            @change="onYearChange">
            <a-select-option v-for="item in yearList" :key="item" :value="item">{{ item }}</a-select-option>
          </a-select>
          <img src="@/assets/Icons/time.svg" alt=""
            style="float:right;width: 16px;height: 16px;position:absolute;right:84px;top:11px;z-index:99">
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <a-spin :spinning="wt3tSpinning">
        <div class="container">
          <div class="report">
            <div class="report-content" style="width: 792px;">
              <div
                style="width: 754px;display: flex;justify-content: space-between;align-items: center;font-family: GoogleSans-Bold;font-size: 28px; margin-bottom: 27px;">
                <div style="display: flex;align-items: center;">Weekly Top 3 Things</div>


              <a-button  v-if="!isEdit"  style="height: 48px;border-radius: 8px;background: #1A73E8; display: flex;align-items: center; font-family: GoogleSans-Regular;" type="primary" 
                @click="changeEditStatus">
                  <svg width="24" height="24" style="fill:#fff;margin-right: 8px;">
                    <use xlink:href="#icon-btn"></use>
                  </svg>
                  Edit
                </a-button>
              <div v-else style="display: flex;align-items: center;gap: 16px;">
               
                <a-button ghost style="height: 48px;border-radius: 8px; border: 2px solid #1A73E8; color:#1A73E8;font-weight: 500; display: flex;align-items: center; font-family: GoogleSans-Regular;" type="primary" 
                @click="addWt3tList">
                  <svg width="24" height="24" style="fill:#fff;margin-right: 8px;">
                    <use xlink:href="#icon-add"></use>
                  </svg>
                  Add a thing
                </a-button>
                <a-button style="height: 48px;border-radius: 8px;background: #1A73E8; display: flex;align-items: center; font-family: GoogleSans-Regular;" type="primary" 
                @click="saveWt3tList">
                  <svg width="24" height="24" style="fill:#fff;margin-right: 8px;">
                    <use xlink:href="#icon-save"></use>
                  </svg>
                  Save
                </a-button>
              </div>
                
              </div>
              <!-- 编辑 -->
              <draggable v-model="wt3tList" :options="{ handle: '.handle',animation: 200  }" v-if="isEdit&&wt3tList.length > 0">
                <!-- 富文本 -->
               <div v-for="item in wt3tList" :key="item.key" style="background-color: #fff; max-width: 754px;padding: 24px;display: flex; flex-direction: column;align-items: flex-start;gap: 16px; border-radius: 8px;box-shadow: 0px 0px 15px 1px rgba(17, 17, 17, 0.06);margin-bottom: 32px;">
                  
                  <div style="width: 100%;font-size: 16px;font-family: GoogleSans-Medium;color: #333; display: flex; align-items: center;justify-content: space-between;">
                    Topic:
                    <div style="display: flex; align-items: center;gap: 8px;">
                      <a-popconfirm title="确定删除吗?" ok-text="Yes" cancel-text="No"
                        @confirm="deleteWt3tList(item.key)">
                        <svg width="18" height="18" style="">
                          <use xlink:href="#icon-wtdelete"></use>
                        </svg>
                      </a-popconfirm>
                      <svg class="handle" width="18" height="18">
                        <use xlink:href="#icon-handle"></use>
                      </svg>
                    </div>
                    
                  </div>
                  <a-input class="sp-input" style="width: 100%;" placeholder="标题：本周重要的工作或者发现，以动作开始，结果导向" v-model="item.wt3t_topic" />
                  
                  <div style="font-size: 16px;font-family: GoogleSans-Medium;color: #333;">Details:</div>
                  <div style="position: relative; width: 100%;">
                    <quill-editor style="width: 100%; height: 400px; border: 1px solid #E8E8E8;border-radius: 4px; color: #333;"
                      ref="myQuillEditor" class="quill-editor-wt3t" v-model="item.wt3t_content" :options="editorOptions">
                    </quill-editor>
                    <div style="color: #999;font-size: 12px; position: absolute;top: 12px;right: 16px; font-style: italic;">为选中内容应用样式/添加超链接</div>
                  </div>
               </div>
              </draggable>
              <!-- 有 -->
              <div v-if="!isEdit&&wt3tList.length > 0">
                <div v-for="item in wt3tList" :key="item.key" style="width: 754px;
                    min-height: 176px;
                    background-color: #fff;
                    box-shadow: 0 0 15px 1px rgba(17, 17, 17, .06);
                    border-radius: 8px;
                    margin-bottom: 27px;
                    overflow: hidden;">
                <div style="background-color: #f0f0f0;
                      padding: 20px 24px;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      font-family: GoogleSans-Bold;
                      font-size: 20px;">
                  {{ item.wt3t_topic }}
                </div>
                <div class="wt3t-content" v-html="item.wt3t_content" style="padding: 12px 24px;color: #666;">
                </div>

                </div>
              </div>
              <!-- 没有 -->
              <div v-if="!wt3tList || wt3tList.length == 0" style="width: 754px;
                    min-height: 200px;
                    background-color: #fff;
                    box-shadow: 0 0 15px 1px rgba(17, 17, 17, .06);
                    border-radius: 8px;
                    margin-bottom: 27px;">
                <img src="@/assets/Images/none.png" alt=""
                  style="width: 64px;height: 64px;opacity: 0.5;margin-top:38px;margin-left:360px;">
                <div
                  style="margin-left: 328px;margin-top:14px;font-family: GoogleSans-Regular;font-size: 16px;line-height: 24px;color: #bbbbbb;opacity: 0.5;">
                  Nothing Added Yet</div>
              </div>

            </div>

            <div id="report-menu" class="report-menu">
              <!-- 用户信息 -->
              <div class="info-prof" style="display: flex">
                <div class="info-prof-avatar">
                  <img v-if="searchAvatar && workList && workList.employee_info" :src="workList.employee_info.profile_picture" alt="">
                  <img v-if="groupAvatar && groupWorkList && groupWorkList.group_info"
                    :src="'https://corp.impr-inc.com/group_avatar/' + groupWorkList.group_info.group_avatar" alt="">
                  <img v-if="!searchAvatar && !groupAvatar" src="@/assets/Images/defaultavatar.jpeg" alt="">
                </div>
                <div style="margin-left:12px;display:flex;flex-direction:column">
                  <div v-if="workList && workList.employee_info" class="info-prof-name">{{
                    workList.employee_info.nickname }}
                  </div>
                  <div v-if="groupWorkList && groupWorkList.group_info" class="info-prof-name">{{
                    groupWorkList.group_info.group_name }}</div>
                  <div v-if="workList && workList.employee_info" class="info-prof-offer">{{
                    workList.employee_info.job_title
                  }}</div>
                  <div v-if="groupWorkList && groupWorkList.group_info" class="info-prof-offer">{{
                    groupWorkList.group_info.group_email }}</div>
                </div>
              </div>
              <!--   切换   -->
              <div style="margin-top:28px;max-height: 1200px;overflow: auto;">
                <div v-for="(item, index) in weekList" :key="item.year+'-'+item.week">
                  <div v-if="chooseWeek && item.week == chooseWeek.split('-')[1] && item.year == chooseWeek.split('-')[0]"
                    style="display: flex;align-items: center; padding: 12px 24px;background-color: #E9F0FD;border-radius: 40px 0 0 40px;">
                    <svg width="24" height="24" style="fill:#2177E9">
                      <use xlink:href="#icon-tab"></use>
                    </svg>
                    <div style="margin-left: 24px;">
                      <div style="color: #2177E9;font-size: 16px;font-family: GoogleSans-Medium;">Week {{ item.week }}, {{ item.year }}</div>
                      <div style="color: rgba(33, 119, 233, 0.50);font-size: 12px;">{{ getWeekDateRange(item.year, item.week) }}</div>
                    </div>
                    <!-- <div v-if="item.list&&item.list.length >=3" style="margin-left: 24px;border-radius: 999px;background: #ECF8F2;padding: 4px 8px;color: #39986B;font-weight: 500;">{{item.list.length}} / 3</div>
                    <div v-else-if="!item.list" style="margin-left: 24px;border-radius: 999px;background: #FEEFEF;padding: 4px 8px;color: #E6666C;font-weight: 500;">0 / 3</div>
                    <div v-else style="margin-left: 24px;border-radius: 999px;background: #FEEFEF;padding: 4px 8px;color: #E6666C;font-weight: 500;">{{item.list.length}} / 3</div> -->
                  </div>

                  <div @click="onTabChange(item.year, item.week, index)" v-else-if="!isEdit"
                    style="display: flex;align-items: center; padding: 12px 24px;border-radius: 40px 0 0 40px;">
                    <svg width="24" height="24" style="fill:#333">
                      <use xlink:href="#icon-tab"></use>
                    </svg>
                    <div style="margin-left: 24px;">
                      <div style="color: #333;font-size: 16px;font-family: GoogleSans-Medium;">Week {{ item.week }}, {{ item.year }} </div>
                      <div style="color: rgba(51, 51, 51, 0.50);font-size: 12px;">{{ getWeekDateRange(item.year, item.week) }}</div>
                    </div>
                    <!-- <div v-if="item.list&&item.list.length >=3" style="margin-left: 24px;border-radius: 999px;background: #ECF8F2;padding: 4px 8px;color: #39986B;font-weight: 500;">{{item.list.length}} / 3</div>
                    <div v-else-if="!item.list" style="margin-left: 24px;border-radius: 999px;background: #FEEFEF;padding: 4px 8px;color: #E6666C;font-weight: 500;">0 / 3</div>
                    <div v-else style="margin-left: 24px;border-radius: 999px;background: #FEEFEF;padding: 4px 8px;color: #E6666C;font-weight: 500;">{{item.list.length}} / 3</div> -->
                  </div>
                  <a-popconfirm
                    v-else
                    title="当前修改还未保存，确定跳转吗?"
                    ok-text="Yes"
                    cancel-text="No"
                    @confirm="onTabChange(item.year, item.week, index)"
                  >
                  <div
                    style="display: flex;align-items: center; padding: 12px 24px;border-radius: 40px 0 0 40px;">
                    <svg width="24" height="24" style="fill:#333">
                      <use xlink:href="#icon-tab"></use>
                    </svg>
                    <div style="margin-left: 24px;">
                      <div style="color: #333;font-size: 16px;font-family: GoogleSans-Medium;">Week {{ item.week }}, {{ item.year }} </div>
                      <div style="color: rgba(51, 51, 51, 0.50);font-size: 12px;">{{ getWeekDateRange(item.year, item.week) }}</div>
                    </div>
                   </div>
                  </a-popconfirm>

                </div>
              </div>
            </div>
          </div>
        </div>
        </a-spin>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
    <!-- <a-modal :title="modalHeader" :visible="visible" @ok="handleOk"
      @cancel="handleCancel" width="740px">
      <div style="display: flex; justify-content: space-between; align-items: center; font-size: 16px; font-family: GoogleSans-Medium;">
        Week:
        <a-week-picker :disabled="modalWeekDisabled" class="sp-input" style="width: 160px;margin-right: 340px;" placeholder="Select week" :value="modalWeek"
          @change="onWeekChange" />
      </div>
      <div style="display: flex;justify-content: space-between;align-items: center; margin-top: 24px;font-size: 16px;font-family: GoogleSans-Medium;">
        Topic:
        <a-input class="sp-input" style="width: 500px;" placeholder="以动词开始的、行动导向的标题" :value="modalTitle" @change="onTitleChange" />
      </div>
      <div style="display: flex; justify-content: space-between;margin-top: 24px; position: relative;font-size: 16px;font-family: GoogleSans-Medium;">
        <span style="margin-top: 8px;">Progress & Findings:</span>
        <quill-editor style="width: 500px; height: 400px; border: 1px solid #d9d9d9;border-radius: 4px;"
          ref="myQuillEditor" class="quill-editor-wt3t timeline-textarea" v-model="modalContent" :options="editorOptions">
        </quill-editor>
        <div style="color: #999;font-size: 12px; position: absolute;top: 12px;right: 142px; font-style: italic;">为选中内容应用样式/添加超链接</div>
      </div>
    </a-modal> -->
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'
import draggable from 'vuedraggable'

moment.suppressDeprecationWarnings = true

export default {
  name: 'Report',
  components: {
    Bug,
    draggable
  },
  inject: ['reload'],
  data() {
    return {

      moment,                                                           //  日期
      dateFormat: 'MM-DD-YYYY',                                         //  日期格式
      todayDate: moment()                                               //  今天日期
        .format()
        .slice(0, 10),
      searchName: '',                                                   //  搜索人名
      searchList: [],                                                   //  搜索下拉框
      processData: [],                                                  //  进度值
      userList: '',                                                     //  员工列表
      groupList: [],                                                    //  所有组信息
      workList: '',                                                     //  个人工作报告列表
      groupWorkList: '',                                                //  团队工作报告列表
      curUserId: '',                                                    //  当前员工编号
      groupId: '2',                                                     //  当前组别编号
      groupName: '',                                                    //  当前组别名称
      avatar: '',                                                       //  当前员工头像
      searchAvatar: '',                                                 //  搜索员工头像
      searchUserId: '',                                                 //  查找员工编号
      groupAvatar: false,                                               //  分组头像
      //  图标颜色切换 tab切换
      current: '0',
      rootSubmenuKeys: ['0', '1', '2', '3', '4', '5', '6', '7'],        //  所有tab页
      openKeys: ['0'],                                                  //  打开tab页
      contentVisible: true,                                              //  wt3t内容加载状态
      teamSpinning: false,                                              //  team内容加载状态
      indexMark: '-1',                                                  //  默认tab标记
      //  日期切换   
      workDateSelect: '',                                               //  我的工作记录日期
      reportDate: '',                                                   //  团队时间
      reportStartDate: '',                                              //  开始时间
      reportEndDate: '',                                                //  结束时间
      reportStatus: '',                                                 //  报告状态
      //  工作报告内容
      // workId: '',                                                       //  工作报告id
      // workDate: '',                                                     //  工作报告日期
      // workTitle: '',                                                    //  工作报告标题
      // workContent: '',                                                  //  工作报告内容
      // workProcess: '100%',                                              //  工作报告进度
      // workEditStatus: true,                                             //  添加/修改状态
      // emailButtonStatus: '',                                             //  邮件发送按钮
      // groupStatus: false,

      // WT3T
      isEdit: false,                                        //  是否展示报告内容
      wt3tSpinning: false, 
      chooseWeek: null,
      wt3tList: [],
      weekList: [],
      year: String(moment().weekYear()),
      week: String(moment().isoWeek()),

      // modalId: '',
      // modalHeader:'',
      // modalWeek: moment().week(),
      // modalYear: moment().format('YYYY'),
      // visible: false,
      // modalTitle: '',
      // modalContent: '',
      // 富文本
      editorOptions: {
        placeholder: '对叙事结构不熟悉的同事\n可以参考的内容选择：\n这个项目的原因/目标/背景；\n现在的情况，未来的目标；\n上周的进展，之后的计划；\n遇到的困难，需要的支持；',
        theme: 'snow',
        formats: [
          'header', 'bold', 'italic', 'underline', 'link', 'list', 'indent'
        ],
        modules: {
          toolbar: [
            // [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'link', { list: 'bullet' }, { list: 'ordered' },{ 'indent': '-1' }, { 'indent': '+1' }],
          ],
          keyboard: {
            bindings: {
              // 禁用自动列表功能
              'list autofill': {
                key: ' ',
                collapsed: true,
                format: ['list'],
                prefix: /^(1\.|-)$/,
                handler: function() {
                  // 返回 true 阻止默认行为
                  return true;
                }
              },
              // Tab 键用于增加缩进
              tab: {
                key: 9,
                handler: function() {
                  this.quill.format('indent', '+1');
                  return false;
                }
              },
              // Shift+Tab 用于减少缩进
              'remove tab': {
                key: 9,
                shiftKey: true,
                handler: function() {
                  this.quill.format('indent', '-1');
                  return false;
                }
              }
            }
          }
        }
      }

    }
  },
  computed: {
    yearList: function () {
      const currentIsoYear = moment().weekYear();
      return [currentIsoYear, currentIsoYear - 1, currentIsoYear - 2];
    },
  },
  watch: {
    '$route'() {
      if (this.$route.params.name == undefined) {
        this.searchUserId = this.curUserId
        this.getUserWorkReport(this.searchUserId)
        this.getWt3tList(this.searchUserId)
      } else if (this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') == -1) {
        this.userList.filter(item => {
          if (this.$route.params.name == item.username) {
            this.searchUserId = item.employee_id
            this.getUserWorkReport(this.searchUserId)
            this.getWt3tList(this.searchUserId)
          }
        })
      } else if (this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') != -1) {
        this.groupList.filter(item => {
          const $name = this.$route.params.name.split('group')[1]
          if ($name == item.group_name.split(' ')[1]) {
            this.groupId = item.group_id
            this.groupName = item.group_name
            this.getGroupWorkReport()
          }
        })
      } else {
        this.searchUserId = this.curUserId
        this.getUserWorkReport(this.searchUserId)
        this.getWt3tList(this.searchUserId)
      }
      this.initPage()
    }
  },
  methods: {
    // showModalAdd() {
    //   if(this.searchUserId == this.curUserId){
    //     this.modalHeader = 'Add a thing';
    //     this.modalId = '';
    //     this.modalTitle = '';
    //     this.modalContent = '<p>必须填写的内容： </p><p>本周在做的事情，目标是什么，是否达到；</p><p>如果达到了，是如何完成的，以及下一步的计划；</p><p> 如果没有达到，遇到了什么困难，（未来）可以怎么解决；</p>';
    //     this.modalWeek = moment();
    //     this.visible = true;
    //     this.modalWeekDisabled = false;
    //   }else{
    //     this.$message.warning('只能添加自己的WT3T');
    //   }
    // },

    // showModalEdit(item) {
    //   console.log(item);
    //   if(this.searchUserId == this.curUserId){
    //     this.modalHeader = 'Edit a thing';
    //     this.modalId = item.id;
    //     this.visible = true;
    //     this.modalWeekDisabled = true;
    //     this.modalWeek = moment(item.year+'-'+item.week.padStart(2, '0'), "GGGG-[W]WW");
    //     this.modalTitle = item.wt3t_topic;
    //     this.modalContent = item.wt3t_content;
    //   }else{
    //     this.$message.warning('只能编辑自己的WT3T');
    //   }
    // },

    changeEditStatus(){
      this.isEdit = !this.isEdit;
    },
    saveWt3tList() {
      if (this.wt3tList.length < 3) {
        this.$message.warning('每周不可少于3件事情');
        return;
      }
      // if(this.modalId==''){
      //   this.$post(api.tool.addWt3t, {
      //     token: localStorage.impr_token,
      //     timestamp: Date.parse(new Date()),
      //     employee_id: this.curUserId,
      //     data: this.wt3tList,
      //     year: this.year,
      //     week: this.week,
      // }).then((res) => {
      //   if (res.code === 200) {
      //     this.visible = false;
      //     this.getWt3tList(this.curUserId);
      //   }
      // })
      // }else{
      
      this.wt3tSpinning = true;
      this.$post(api.tool.updateWt3t , {
        token: localStorage.impr_token,
        timestamp: Date.parse(new Date()),
        employee_id: this.curUserId,
        year: this.year,
        week: this.week,
        data: this.wt3tList,
      }).then((res) => {
        if (res.code === 200) {
          this.isEdit = false;
          this.$message.success('保存成功');
          this.wt3tSpinning = false;
          this.getWt3tList(this.curUserId);
        }
      })
      // }
    },
    // handleCancel() {
    //   this.visible = false;
    // },

    getWt3tList() {
      this.wt3tSpinning = true;
      this.$post(api.tool.getWt3tList, {
        token: localStorage.impr_token,
        timestamp: Date.parse(new Date()),
        employee_id: this.curUserId,
        year: this.year,
        week: this.week,
        // ee_id: id
        ee_id:this.curUserId,
      }).then((res) => {
        console.log(res.list);
        this.wt3tList=[];
        if (res.code === 200 && res.list.length > 0) {
          let key = 0;
          res.list.forEach(item => {
            this.wt3tList.push({
              // id: item.id,
              key: key,
              wt3t_topic: item.wt3t_topic,
              wt3t_content: item.wt3t_content,
            });
            key++;
          });
        }
        this.chooseWeek = this.year + "-" + this.week + '-0';
        this.isEdit = false;
        this.wt3tSpinning = false;
        // this.wt3tList = res.list;
        // if (res.code === 200 && res.list.length > 0) {
        //   const result = [];

        //   res.list.forEach(item => {
        //     // 查找是否已存在相同week和year的分组
        //     const existingGroup = result.find(group =>
        //       group.week === item.week && group.year === item.year
        //     );

        //     if (existingGroup) {
        //       // 如果存在，直接添加到该分组的list中
        //       existingGroup.list.push({
        //         id: item.id,
        //         wt3t_topic: item.wt3t_topic,
        //         wt3t_content: item.wt3t_content,
        //         year: item.year,
        //         week: item.week,
        //         addtime: item.addtime
        //       });
        //     } else {
        //       // 如果不存在，创建新分组
        //       result.push({
        //         week: item.week,
        //         year: item.year,
        //         list: [{
        //           id: item.id,
        //           wt3t_topic: item.wt3t_topic,
        //           wt3t_content: item.wt3t_content,
        //           year: item.year,
        //           week: item.week,
        //           addtime: item.addtime
        //         }]
        //       });
        //     }
        //   });

        //   // 按年份和周数排序
        //   this.wt3tList = result.sort((a, b) => {
        //     if (a.year !== b.year) {
        //       return b.year - a.year;
        //     }
        //     return b.week - a.week;
        //   });
        // }else{
        //   this.wt3tList = [];
        // }
      });
    },
    addWt3tList(){
      this.wt3tList.push({
        // id: '',
        key: this.wt3tList.length,
        wt3t_topic: '',
        wt3t_content: '<p>对叙事结构不熟悉的同事</p><p>可以参考的内容选择：</p><p>这个项目的原因/目标/背景；</p><p>现在的情况，未来的目标；</p><p>上周的进展，之后的计划；</p><p>遇到的困难，需要的支持；</p>',
      });
    },
    deleteWt3tList(key) {
      this.wt3tList = this.wt3tList.filter((item) => item.key !== key);
    },
    getWeeKList(alignWithCurrentWeek = true) {
      const targetYear = parseInt(this.year);
      
      if (isNaN(targetYear)) {
        console.error("this.year 不是一个有效的年份");
        return [];
      }

      const currentWeekYear = moment().weekYear();
      let weekCount;
      
      // 如果是当前ISO周年，只显示到当前周
      if (currentWeekYear === targetYear) {
        weekCount = moment().isoWeek();
      } else {
        // 否则显示该年的全部周数
        weekCount = moment(`${targetYear}-12-31`).isoWeeksInYear();
      }
      
      const weekList = [];
      for (let week = 1; week <= weekCount; week++) {
        weekList.unshift({
          year: String(targetYear),
          week: String(week)
        });
      }
      this.weekList = weekList;

      if (alignWithCurrentWeek && currentWeekYear === targetYear) {
        this.week = String(moment().isoWeek());
      } else {
        this.week = weekList[0].week;
      }
    },


    onTabChange(year, week, index) {
      this.chooseWeek = year + "-" + week + '-' + index;
      this.year = year;
      this.week = week;
      this.getWt3tList();
    },
    onYearChange() {
      this.getWeeKList(false);
      this.week = this.weekList[0].week;
      this.chooseWeek = this.year + "-" + this.week + '-0';
      this.getWt3tList();
    },
    //onWeekChange(date) {
    //  this.modalWeek = date;
    //},
    // onTitleChange(e) {
    //   this. = e.target.value;
    // },
    // onEdit(item) {
    //   this.modalTitle = item.wt3t_topic;
    //   this.modalContent = item.wt3t_content;
    // },
    // onDelete(item) {
    //   this.$post(api.tool.deleteWt3t, {
    //     token: localStorage.impr_token,
    //     employee_id: this.curUserId,
    //     timestamp: Date.parse(new Date()),
    //     id: item.id
    //   }).then((res) => {
    //     if (res.code === 200) {
    //       this.getWt3tList(this.curUserId);
    //     }
    //   });
    // },
    // 路由 - 初始化页面
    initPage() {
    },
    //  tab切换
    handleClick(e) {
      this.current = e.key
    },

    getWeekDateRange(year, week) {
      const firstDayOfYear = new Date(year, 0, 1);
      const firstDayWeekDay = firstDayOfYear.getDay();
      const firstWeekStart = new Date(year, 0, 1 - firstDayWeekDay + 1);
      
      const targetWeekStart = new Date(firstWeekStart);
      targetWeekStart.setDate(firstWeekStart.getDate() + (week - 1) * 7);
      
      const targetWeekEnd = new Date(targetWeekStart);
      targetWeekEnd.setDate(targetWeekStart.getDate() + 6);
      
      const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${date.getFullYear()}/${month}/${day}`;
      };
      
      return `${formatDate(targetWeekStart)} - ${formatDate(targetWeekEnd)}`;
    },
    //  输入框内容改变 过滤名单
    // onNameChange(name) {
    //   if (name == '') {
    //     this.searchList = []
    //   } else {
    //     this.searchList = this.userList.filter(item => {
    //       return item.username.indexOf(name.toLowerCase()) != -1 || item.legal_name.indexOf(name) != -1
    //     })
    //   }
    // },
    //  选择后查询更改查询id 发起请求
    // onNameSelect(info) {
    //   this.searchUserId = info.split(',')[0]
    //   this.searchName = info.split(',')[1]
    //   //  发起请求
    //   this.urlNamePathLinkClose(info.split(',')[2])
    // },
    //  获取员工列表
    getUserList() {
      this.$post(api.tool.getUserList, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.userList = res.list
          if (this.$route.params.name == undefined) {
            this.searchUserId = this.curUserId
            this.getUserWorkReport(this.searchUserId)
            this.getWt3tList(this.searchUserId)
          } else if (this.$route.params.name !== undefined && this.$route.params.name.indexOf('group') == -1) {
            this.userList.filter(item => {
              if (this.$route.params.name == item.username) {
                this.searchUserId = item.employee_id
                this.getUserWorkReport(this.searchUserId)
                this.getWt3tList(this.searchUserId)
              }
            })
          }
        }
      })
    },
    //  获取员工工作报告
    getUserWorkReport(id) {
      // this.dateInit()
      this.searchUserId = id
      this.contentVisible = true
      this.groupAvatar = false
      //  发送请求
      this.wt3tSpinning = true  
      // console.log('员工id:' + this.searchUserId, '报告日期范围:' + this.reportStartDate, this.reportEndDate, '员工报告获取')
      this.$post(api.tool.getWorkRecord, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        s_date: this.reportStartDate,
        e_date: this.reportEndDate,
        ee_id: this.searchUserId
      }).then((res) => {
        if (res.code === 200) {
          this.workList = res.list
          this.groupWorkList = ''

          if (this.workList.employee_info != null && this.workList.employee_info.profile_picture != '' && this.workList.employee_info.profile_picture != null) {
            this.searchAvatar = true
          } else {
            this.searchAvatar = false
          }
          this.wt3tSpinning = false
        }
      })
    },

    //  回到自己页面
    backToReport() {
      this.$router.replace({ path: '/wt3t' })
      this.reload()
    },
    // 通过链接跳转
    // urlNamePathLink(username) {
    //   this.$router.replace({ path: '/wt3t/' + username })
    // },
    // urlNamePathLinkClose(username) {
    //   this.$router.replace({ path: '/wt3t/' + username })
    // },
    
    // 动态生成缩进样式
    generateIndentStyles() {
      const style = document.createElement('style')
      let css = ''
      
      // 生成1-10级缩进样式
      for (let i = 1; i <= 10; i++) {
        css += `
          .wt3t-content .ql-indent-${i},
          .ql-editor .ql-indent-${i} {
            margin-left: ${i * 3}em;
            padding-left: 0 !important;
          }
        `
      }
      
      style.textContent = css
      document.head.appendChild(style)
    }
  },
  created() {
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id
      this.searchUserId = localStorage.impr_id
      this.getUserList()
      this.getWeeKList();
      // this.getWt3tList(this.searchUserId)
    } else {
      // this.$router.push({ path: '/login' })
    }
  },
  mounted() {
    // const currentDate = new Date();
    //   if (currentDate.getMonth() === 11 && currentDate.getDate() >= 25) {
    //     this.year = String(currentDate.getFullYear() + 1);
    //   }
    // 动态生成缩进样式
    console.log("week:"+moment().week(),);
    this.generateIndentStyles()
  },
}
</script>
<style>
.ant-btn,
.ant-input,
.ant-calendar-picker-input {
  font-size: 16px;
  font-family: GoogleSans-Regular;
}
.ant-calendar-picker-input {
  line-height: 24px;
}
.ant-modal-title {
  font-size: 20px;
  font-family: GoogleSans-Medium;
}
.quill-editor-wt3t.ql-blank::before {
  font-style: normal !important; /* 使用 !important 确保样式覆盖 */
}
.sp-input .ant-calendar-picker-input,
.sp-input.ant-input {
  height: 48px !important;
}
.ant-modal-footer .ant-btn {
  padding: 8px 24px;
  width: 100px;
  height: auto;
}
.quill-editor-wt3t p,
.quill-editor-wt3t ul,
.quill-editor-wt3t ol,
.wt3t-content p,
.wt3t-content ul,
.wt3t-content ol{
  font: 15px / 1.5 Arial, Helvetica, sans-serif;
  margin-top: 1em !important;
  margin-bottom: 1em !important;
}
.quill-editor-wt3t ul,
.quill-editor-wt3t ol,
.wt3t-content ul,
.wt3t-content ol {
  padding-left: 40px !important;
}
.quill-editor-wt3t li,
.wt3t-content li {
  margin-left: 15px;
}
</style>
<style scoped>
/* Common */
#components-layout-demo-basic a-select {
  background: #1a73e8;
}

#components-layout-demo-basic .ant-layout {
  background: #fff;
}

#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}

#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}

.container {
  /*width: 60%;*/
  width: 1120px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}

.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* 日期选择 */
#components-layout-demo-basic>>>.ant-calendar-picker-input.ant-input {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  color: #333333;
  background-color: #ffffff;
  cursor: pointer;
}

#components-layout-demo-basic>>>.ant-calendar-range-picker-separator {
  margin-top: 4px;
}

#components-layout-demo-basic>>>.ant-calendar-range-picker-input {
  cursor: pointer;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1a73e8;
}

#components-layout-demo-basic>>>.ant-input {
  height: 40px;
  border-radius: 8px;
  /* background-color: #f1f3f4; */
  font-size: 14px;
  border: none;
  border: 1px solid #E8E8E8;
}

#components-layout-demo-basic>>>.ant-input::placeholder {
  font-size: 14px;
  color: #bbbbbb;
}

#components-layout-demo-basic>>>.certain-category-icon {
  font-size: 21px;
  color: #555555;
}

/* report */
.report {
  min-height: 1091px;
  width: 100%;
  margin-top: 40px;
  display: flex;
  z-index: 99;
}

.report-menu {
  width: 320px;
  display: flex;
  flex-direction: column;
}

/* avatar name */
.info-prof {
  height: 81px;
}

.info-prof-avatar {
  margin-top: 5px;
  margin-left: 4px;
  width: 72px;
  height: 72px;
}

.info-prof-avatar img {
  height: 100%;
  width: 100%;
  border-radius: 50%;

}

.info-prof-name {
  height: 16px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  line-height: 19px;
  color: #222222;
  margin-top: 23px;
}

.info-prof-offer {
  height: 12px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 19px;
  color: #555555;
  margin-top: 10px;
}

/* tab */
#components-layout-demo-basic>>>.ant-menu-item {
  display: flex;
  align-content: center;
  border-radius: 0 22px 22px 0;
  height: 44px;
}

#components-layout-demo-basic>>>.first-sub-menu .ant-menu-submenu-arrow::after,
#components-layout-demo-basic>>>.first-sub-menu .ant-menu-submenu-arrow::before {
  width: 0;
  height: 0;
}

#components-layout-demo-basic>>>.ant-menu-submenu-title {
  height: 44px;
  background-color: #ffffff;
  border-radius: 0 24px 24px 0;
  color: #222222;
  padding-top: 2px;

}

#components-layout-demo-basic>>>.ant-menu-submenu-open .ant-menu-submenu-title {
  height: 44px;
  background-color: #e9f0fd;
  color: #2177e9;
  border-radius: 0 24px 24px 0;
}

#components-layout-demo-basic>>>.ant-menu-item img {
  width: 24px;
  height: 24px;
  margin-top: 10px;
}

#components-layout-demo-basic>>>.ant-menu-submenu img {
  width: 24px;
  height: 24px;
}

#components-layout-demo-basic>>>.ant-menu-item span,
#components-layout-demo-basic>>>.ant-menu-submenu span.sub-menu-title {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  /*color: #222222;*/
  margin-left: 18px;
}

#components-layout-demo-basic>>>.ant-menu-submenu-selected {
  color: #222222;
}

#components-layout-demo-basic>>>.ant-menu-item.ant-menu-item-selected,
#components-layout-demo-basic>>>.menu-item-user.ant-menu-item.ant-menu-item-selected {
  background-color: #ffffff;
  color: #2177e9;
}

#components-layout-demo-basic>>>.ant-calendar-picker-icon {
  display: none;
}

.ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  border: 0;
}

#components-layout-demo-basic>>>.reportDateSelect .ant-calendar-picker-input {
  height: 40px;
  border: solid 1px #e5e5e5;
  color: rgba(0, 0, 0, 0.65);
  width: 150px;
}

#components-layout-demo-basic>>>.ant-calendar-picker-input.ant-input-disabled {
  background-color: #fafafa;
  color: #bbbbbb;
}

/* timeline */
.ant-timeline {
  margin-top: 30px;
}

#components-layout-demo-basic>>>.ant-timeline-item-head {
  width: 14px;
  height: 14px;
  background-color: #bbbbbb;
  border-radius: 7px;
  border: 0;
  margin-left: 1px;
}

.timeline-item-first-wrap {
  position: relative;
  width: 792px;
  /* height: 265px; */
  background-color: #ffffff;
  border-radius: 8px;
  border: solid 2px rgba(33, 119, 233, 0.5);
  padding: 24px 25px 24px 23px;
  margin-top: 22px;
  /*margin-left: 22px;*/
}

/*#components-layout-demo-basic >>> .ant-timeline-item:first-child .ant-timeline-item-head {*/
/*  width: 16px;*/
/*  height: 16px;*/
/*  background-color: #2177e9;*/
/*  border-radius: 8px;*/
/*  margin-left: 0;*/
/*}*/
#components-layout-demo-basic>>>.ant-timeline-item-tail {
  margin-left: 3px;
}

.timeline-time {
  height: 20px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  color: #222222;
  line-height: 19px;
  letter-spacing: 0;
  margin-top: 5px;
}

.timeline-time:hover {
  color: #2177e9;
}

.first-timeline-item {
  display: flex;
}

.first-timeline-item .timeline-time {
  color: #2177e9;
}

#components-layout-demo-basic>>>.group-timeline .ant-timeline-item-tail,
#components-layout-demo-basic>>>.group-timeline .ant-timeline-item-head {
  display: none;
}

#components-layout-demo-basic>>>.process-select .ant-select-selection {
  width: 150px;
  height: 40px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  margin-top: 12px;
}

#components-layout-demo-basic>>>.process-select .ant-select-selection__rendered {
  margin-right: 24px;
  margin-top: 4px;
}

#components-layout-demo-basic>>>.process-select .ant-select-arrow i svg {
  display: none;
}

#components-layout-demo-basic>>>.process-select .ant-select-arrow {
  /* display: none; */
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 9px solid #2177e9;
  border-radius: 3px;
}

#components-layout-demo-basic .timeline-textarea {
  width: 745px;
  height: 160px;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-top: 12px;
  resize: none;
}

#components-layout-demo-basic .timeline-textarea::placeholder {
  color: #bbbbbb;
}

#components-layout-demo-basic .timeline-textarea-history {
  width: 754px;
  min-height: 176px;
  background-color: #ffffff;
  box-shadow: 0px 0px 15px 1px rgba(17, 17, 17, 0.06);
  border-radius: 8px;
  margin-top: 27px;
}

#components-layout-demo-basic>>>.ant-timeline-item-content {
  display: flex;
  flex-direction: column;
  margin-left: 38px;
}

#components-layout-demo-basic .timeline-submit {
  width: 150px;
  height: 40px;
  background-color: #2177e9;
  border-radius: 8px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #ffffff;
  margin-top: 12px;
}

/* 编辑报告 */

.report-wrap {
  display: flex;
  align-items: center;
  min-height: 30px;
  margin-left: 32px;
  /*margin-top: 9px;*/
  border-bottom: 1px solid #f5f5f5;
  padding-top: 15px;
  padding-bottom: 15px;
}

.report-wrap:last-child {
  border-bottom: 0;
}

.record-title {
  width: 100px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #555555;
}

.record-content {
  width: 460px;
  font-family: "PingFang SC";
  font-size: 14px;
  color: #333333;
}

.record-process {
  width: 38px;
  margin-left: 30px;
}

.delete-icon,
.edit-icon {
  margin-top: 3px;
  margin-left: 15px;
}

svg {
  cursor: pointer;
  z-index: 999;
}

.delete-icon:hover svg {
  fill: #2177e9;
}

.edit-icon:hover svg {
  fill: #2177e9;
}

.group-title {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  color: #222222;
}

.group-title span {
  color: #2177e9;
}

.none {
  display: none;
}
</style>
<style scoped>
.quill-editor .ql-container {
  height: calc(100% - 42px);
  font-size: 14px;
}

.quill-editor .ql-toolbar.ql-snow,
.quill-editor .ql-container.ql-snow {
  border: none;
}

.quill-editor .ql-toolbar.ql-snow {
  border-bottom: 1px solid #e5e5e5;
}

.quill-tip {
  position: absolute;
  font-size: 12px;
  font-style: italic;
  color: #bbb;
  left: 210px;
  /* right: 38px; */
  top: 88px;
  z-index: 3;
}

.ql-tooltip.ql-editing {
  z-index: 2;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
}

.ql-snow .ql-tooltip.ql-editing {
  box-shadow: none;
}

.ql-tooltip.ql-editing input {
  border-radius: 4px;
}

.record-content a {
  color: #0000ee;
  text-decoration: underline;
}
</style>
<style>
.quill-editor-wt3t .ql-editor.ql-blank:before {
  color: #bbb;
  line-height: 36px;
  margin-top: 8px;
}
</style>